import React from 'react'
import Card from '../Card'
import getData from '../Data'
import ProcessData from '../ProcessData'

const Pregunta = props => {
  const { data, pageContext, location } = props
  const allData = getData()
  const { elegidos } = ProcessData(allData)
  const { pregunta } = data
  const bajadahtml = pregunta.bajada
    ? `<p>${pregunta.bajada.split('\n').join('</p><p>')}</p>`
    : null

  return (
    <Card
      pregunta={pregunta}
      title={<span dangerouslySetInnerHTML={{ __html: pregunta.slug }} />}
      description={
        <>
          <div
            className="pt-6"
            dangerouslySetInnerHTML={{ __html: bajadahtml }}
          />
          <h3
            className="leading-tight text-center"
            dangerouslySetInnerHTML={{ __html: pregunta.descripcion }}
          />
        </>
      }
      elegidos={elegidos}
      path={location.pathname}
    />
  )
}

export default Pregunta
